import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { formListParam } from "features/ms6/core/ms6.param";
import {
  formListRepository,
  formListSubmitResponse,
} from "features/ms6/data/ms6.repository";
import { RootState } from "features/config/store";

export enum formListState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: formListState;
  message: string;
}

const initialState: InitialState = {
  status: formListState.initial,
  message: "",
};

export const formList = createAsyncThunk(
  "formList",
  async (param: formListParam, { rejectWithValue }) => {
    try {
      const response: formListSubmitResponse = await formListRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const formListSlice = createSlice({
  name: "formList",
  initialState,
  reducers: {
    resetformList: (state) => {
      state.status = formListState.initial;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(formList.pending, (state) => {
        state.status = formListState.inProgress;
      })
      .addCase(formList.fulfilled, (state, action) => {
        if (action.payload) {
          const { message } = action.payload;
          state.status = formListState.success;
          state.message = message;
        }
      })
      .addCase(formList.rejected, (state, action) => {
        state.status = formListState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectFormList = (state: RootState) => state.formList;
export const { resetformList } = formListSlice.actions;
export default formListSlice.reducer;
